<template>
  <div class="container">
    <div class="row py-5 justify-content-center">
      <div class="col-12 col-lg-6 py-5">
        <div class="row border-bottom border-2">
          <div class="col-6 my-auto">
            {{ t("views.account.detail.name") }}
          </div>
          <div class="col-6 text-end">
            <a @click="openModal('name')" href="#accountEditModal" class="btn btn-sm btn-outline-dark mb-1" data-bs-toggle="modal">&bull; {{ t("general.update") }}</a>
          </div>
        </div>
        <div class="row">
          <div class="col-12 fs-4">
            {{ user.lastName }}, {{ user.firstName }}
          </div>
        </div>
        <div class="row border-bottom border-2 mt-5">
          <div class="col-6 my-auto">
            {{ t("views.account.detail.email") }}
          </div>
          <div class="col-6 text-end">
            <a @click="openModal('email')" href="#accountEditModal" class="btn btn-sm btn-outline-dark mb-1" data-bs-toggle="modal">&bull; {{ t("general.update") }}</a>
          </div>
        </div>
        <div class="row">
          <div class="col-12 fs-4">
            {{ user.email }}
          </div>
        </div>
        <div class="row border-bottom border-2 mt-5">
          <div class="col-6 my-auto">
            {{ t("views.account.detail.language") }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 fs-4 mt-2">
            <button @click="setLocale('de-DE')" class="btn btn-sm me-2 mb-1" :class="locale === 'de-DE' ? 'btn-dark' : 'btn-outline-dark'">Deutsch (de-DE)</button>
            <button @click="setLocale('en-GB')" class="btn btn-sm me-2 mb-1" :class="locale === 'en-GB' ? 'btn-dark' : 'btn-outline-dark'">English (en-GB)</button>
            <button @click="setLocale('en-US')" class="btn btn-sm me-2 mb-1" :class="locale === 'en-US' ? 'btn-dark' : 'btn-outline-dark'">English (en-US)</button>
            <button @click="setLocale('fr-FR')" class="btn btn-sm me-2 mb-1" :class="locale === 'fr-FR' ? 'btn-dark' : 'btn-outline-dark'">Français (fr-FR)</button>
          </div>
        </div>
        <div class="row border-bottom border-2 mt-5">
          <div class="col my-auto">
            {{ t("views.account.detail.deleteAccountHeading") }}
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="mt-3">
              {{ t("views.account.detail.deleteAccountText") }}
              <a href="mailto:support@focusmt.de">support@focusmt.de</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
    <AccountEditModal
      :user="user"
      :elementType="userModalElementType"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { i18n } from '@/i18n'
import AccountEditModal from '@/components/account/AccountEditModal.vue'

const store = useStore()
const { t } = useI18n()
const locale = i18n.global.locale

const userModalElementType = ref('')
const user = computed(() => store.state.user)

// Methoden
const openModal = (elementType) => {
  userModalElementType.value = elementType
}

async function setLocale (lang) {
  store.commit('SET_LOADING_STATUS', true)
  await store.dispatch('updateUserDetails', { settings: { language: lang } })
  locale.value = lang
  store.commit('SET_LOADING_STATUS', false)
}
</script>
